import router from './'
import store from '../store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {generateRoutes} from '@/utils'

const loginRoutePath = '/user/login'
const defaultRoutePath = '/dashboard'
NProgress.configure({showSpinner: false})
let isRegRoute = false
router.beforeEach((to, from, next) => {
    document.title = '大鸽饭-' + to.name
    const meta = to.meta || {}
    NProgress.start()
    /* has token */
    if (store.state.user.accessToken) {
        if (to.path === loginRoutePath) {
            /** 已经登录，直接去首页 ***/
            next({path: defaultRoutePath})
            NProgress.done()
        } else {
            const menuTrees = store.state.user.menuTrees || []
            if (!isRegRoute && menuTrees.length > 0) {
                isRegRoute = true
                const dynamicRoutes = generateRoutes(menuTrees)
                dynamicRoutes.forEach(route => {
                    if (!router.getRoutes().some((r) => r.name == route.name)) {
                        router.addRoute(route)
                    }
                })
                next({path: to.fullPath})
                return
            }
            if (!(store.getters.permissions) || store.getters.permissions.length === 0) {
                store.dispatch('queryUser').then(() => {
                    next({...to, replace: true})
                }).catch(() => {
                    store.dispatch('logout').then(() => {
                        next({path: loginRoutePath, query: {redirect: to.fullPath}})
                    })
                })
            } else {
                const query = to.query || {}
                store.commit('ADD_TAG', {
                    name: query.name || to.name,
                    path: to.path,
                    fullPath: to.fullPath,
                    params: to.params,
                    query: to.query,
                    meta: meta
                })

                next()
            }
        }
    } else {
        //判断是否需要认证，没有登录访问去登录页
        if (meta.isAuth === false || to.path.indexOf('login') > 0) {
            // 在免登录名单，直接进入
            next()
        } else {
            next({path: loginRoutePath, query: {redirect: to.fullPath}})
        }
    }
})

router.afterEach(to => {
    NProgress.done()
})
